import * as Yup from "yup";
import * as React from "react";
import Swal from "sweetalert";
import { useNavigate } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { login } from "../../api/fetch";
import { useAuth } from "../../services/AuthContext";

const validationSchema = Yup.object({
  username: Yup.string().required("Username is required"),
  password: Yup.string().required("Password is required"),
});

export const Provider = () => {
  // Getter and Setter State For Email and Password ------>>>>>>>>>
  const [username, setUserName] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [errors, setErrors] = React.useState({});
  const [attempt, setAttempt] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);

  const navigate = useNavigate();
  const { setUser } = useAuth();

  const validateForm = async () => {
    try {
      await validationSchema.validate(
        { username, password },
        { abortEarly: false }
      );
      return null; // No errors
    } catch (err) {
      // Extract errors
      const newErrors = {};
      err.inner.forEach((error) => {
        newErrors[error.path] = error.message;
      });
      return newErrors;
    }
  };

  const handleSubmit = async () => {
    setIsLoading(true);
    const formErrors = await validateForm();
    if (formErrors) {
      setErrors(formErrors);
      setIsLoading(false);
    } else {
      setErrors({});
      console.log("Form submitted with", { username, password });
      mutation.mutate({ username, password });
    }
  };

  const mutation = useMutation({
    mutationFn: (credential) => login(credential),
    onSuccess: (res) => {
      console.log("RESSSS S:::", res);
      if (res?.status) {
        // navigate("/Dashboard");
        setUser(res?.user);
        localStorage.setItem("adminToken", res?.access_token);
        Swal({
          title: "Success",
          text: res?.msg,
          timer: 1000,
          icon: "success",
        });
        navigate("/Dashboard");
        setIsLoading(false);
      } else if (res?.msg === "Failed") {
        setAttempt(true);
        setIsLoading(false);
        Swal(
          {
            text: "Too many failed attempts. Please try again after 30 Seconds.",
            icon: "error",
            timer: 3000,
          }
          //   Swal("Nice!", res?.data?.msg, "success")
        );
      } else {
        Swal(
          {
            title: "Oopps!",
            text: res?.msg,
            icon: "error",
            timer: 3000,
          }
          //   Swal("Nice!", res?.data?.msg, "success")
        );
        setIsLoading(false);
      }
    },
    onError: (error) => {
      console.log("Login ERROR ::", error);
    },
  });

  return {
    username,
    setUserName,
    password,
    setPassword,
    navigate,
    handleSubmit,
    errors,
    attempt,
    setAttempt,
    isLoading,
    setIsLoading,
  };
};
